import {
  FormControlLabel,
  FormHelperText,
  IconButton,
  TextField,
  Typography
} from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { useTheme } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  TableRowHead,
  useStyles
} from "components/request-document/components/Commons";
import { useExtendsionFormPartF } from "components/smart-visa-extension/useExtendsionForm";
import { EXTENSION_DOCUMENT_STEP } from "libs/configs/constant";
import {
  defaultCompanies,
  getErrorMessage,
  mapCompanies
} from "libs/utils/form";
import { get, isError } from "lodash-es";
import React from "react";

export default function PartF() {
  const classes = useStyles();
  const theme = useTheme();

  const { formik, onSaveDraft } = useExtendsionFormPartF();

  const Companies = formik.values.Companies || [];

  return (
    <div className={classes.root}>
      <ContentTitle
        title="APPLICATION FOR SMART VISA EXTENSION"
        subTitle="SMART VISA EXTENSION"
      />
      <Steper isExtend currentStep={0} stepInfo={EXTENSION_DOCUMENT_STEP} />
      <form onSubmit={formik.handleSubmit}>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={5}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part F: Investment in Thailand
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        1. Please select all types of your investment.
                      </InputLabel>

                      <div
                        className={classes.wrapField}
                        style={{ marginTop: 8 }}
                      >
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                name="DirectInvestmentTechnology"
                                value={formik.values.DirectInvestmentTechnology}
                                checked={Boolean(
                                  formik.values.DirectInvestmentTechnology
                                )}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "DirectInvestmentTechnology",
                                    !formik.values.DirectInvestmentTechnology
                                  );
                                }}
                              />
                            }
                            label="Direct investment in technology-based business in Thailand"
                          />
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                name="Investmentthrough"
                                value={formik.values.Investmentthrough}
                                checked={Boolean(
                                  formik.values.Investmentthrough
                                )}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "Investmentthrough",
                                    !formik.values.Investmentthrough
                                  );
                                }}
                              />
                            }
                            label="Investment through a venture capital company which has invested technology-based business in Thailand"
                          />
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                name="DirectInvestmentStartup"
                                value={formik.values.DirectInvestmentStartup}
                                checked={Boolean(
                                  formik.values.DirectInvestmentStartup
                                )}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "DirectInvestmentStartup",
                                    !formik.values.DirectInvestmentStartup
                                  );
                                }}
                              />
                            }
                            label="Direct investment in a startup or an incubation or accelerator business in Thailand"
                          />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <InputLabel>
                      List of companies in which the applicant has invested in
                    </InputLabel>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRowHead>
                <StyledTableCell>Company Name</StyledTableCell>
                <StyledTableCell>Value of shares (Baht)</StyledTableCell>
                <StyledTableCell>
                  Amount of convertible debt (Baht)
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  The same company as the last Smart Visa application
                </StyledTableCell>
              </TableRowHead>

              {Companies.map((companies, index) => {
                if (!companies.Status) return null;

                return (
                  <TableRow key={index}>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            variant="outlined"
                            className={classes.textField}
                            name={`Companies.${index}.CompanyName`}
                            value={formik.values.Companies[index]?.CompanyName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `Companies.${index}.CompanyName`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `Companies.${index}.CompanyName`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            variant="outlined"
                            type="number"
                            className={classes.textField}
                            name={`Companies.${index}.ValueofShares`}
                            value={
                              formik.values.Companies[index]?.ValueofShares
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `Companies.${index}.ValueofShares`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `Companies.${index}.ValueofShares`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            variant="outlined"
                            type="number"
                            className={classes.textField}
                            name={`Companies.${index}.AmountOfConvertibledebt`}
                            value={
                              formik.values.Companies[index]
                                ?.AmountOfConvertibledebt
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `Companies.${index}.AmountOfConvertibledebt`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `Companies.${index}.AmountOfConvertibledebt`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <div
                        className={classes.cellContent}
                        style={{ marginTop: -20 }}
                      >
                        <div className={classes.wrapField}>
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <StyleCheckbox
                                  checked={
                                    formik.values.Companies[index]
                                      ?.SameCompany === true
                                  }
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `Companies.${index}.SameCompany`,
                                      true
                                    );
                                  }}
                                />
                              }
                              label="Yes"
                            />
                            <FormControlLabel
                              control={
                                <StyleCheckbox
                                  checked={
                                    formik.values.Companies[index]
                                      ?.SameCompany === false
                                  }
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `Companies.${index}.SameCompany`,
                                      false
                                    );
                                  }}
                                />
                              }
                              label="No"
                            />
                          </FormGroup>
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell>
                      {index === 0 ? (
                        <div style={{ width: 40 }} />
                      ) : (
                        <>
                          <IconButton
                            style={{
                              width: 40,
                              color: theme.palette.error.main,
                            }}
                            size="small"
                            onClick={async () => {
                              if (
                                get(
                                  formik.values,
                                  `Companies.${index}.companiesId`,
                                  ""
                                )
                              ) {
                                formik.setFieldValue(
                                  `Companies.${index}.Status`,
                                  false
                                );
                              } else {
                                formik.setFieldValue(
                                  "Companies",
                                  Companies.filter((__, i) => i !== index)
                                );
                              }
                            }}
                          >
                            <DeleteForeverIcon />
                          </IconButton>
                          <FormHelperText error={false}> </FormHelperText>
                        </>
                      )}
                    </StyledTableCell>
                  </TableRow>
                );
              })}

              <TableRow>
                <StyledTableCell colSpan={5}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <AddRowButton
                      onClick={() => {
                        formik.setFieldValue("Companies", [
                          ...Companies,
                          mapCompanies(defaultCompanies),
                        ]);
                      }}
                    />
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={5}>
                  <div className={classes.cellContent}>
                    <Bagde number={3} />
                    <div className={classes.wrapField}>
                      {" "}
                      <InputLabel>
                        Total value of shares owned by the applicant (Baht)
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        type="number"
                        className={classes.textField}
                        name={"Totalvalue"}
                        value={formik.values.Totalvalue}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Totalvalue", formik)}
                        helperText={getErrorMessage("Totalvalue", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {/* <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            padding: "21px 35px",
          }}
        >
          <InputLabel>
            Note : In case the applicant has not invested in the same company as
            the last Smart Visa application, please fill in FORM A attached.
          </InputLabel>
        </div> */}
        <ButtonController
          isExtend
          onClickSaveDraft={() => {
            onSaveDraft();
          }}
        />
      </form>
    </div>
  );
}
